/* eslint-disable import/no-anonymous-default-export */

import {
    GET_EVALUATION_CERTIFICATE_PRODUCTS_COUNT,
    GET_EVALUATION_CERTIFICATE_PRODUCTS_COUNT_ERROR,
    GET_EVALUATION_CERTIFICATE_PRODUCTS,
    GET_EVALUATION_CERTIFICATE_PRODUCTS_ERROR,
    GET_EVALUATION_CERTIFICATES_COUNT,
    GET_EVALUATION_CERTIFICATES_COUNT_ERROR,
    GET_EVALUATION_CERTIFICATES,
    GET_EVALUATION_CERTIFICATES_ERROR,
    EVALUATION_CERTIFICATES_LOADING
} from "../actions/types";

const initialState = {
    productsWithEvaluations: [],
    evaluationsCertificates: [],
    isLoading: true,
    certListIsLoading: true,
    success: false,
    count: 0,
    manufacturerCount: 0,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {

        case GET_EVALUATION_CERTIFICATE_PRODUCTS_COUNT:
            return {
                ...state,
                manufacturerCount: payload,
            };
        case GET_EVALUATION_CERTIFICATE_PRODUCTS:
            return {
                ...state,
                productsWithEvaluations: payload,
                isLoading: false,
                success: true,
            };
        case GET_EVALUATION_CERTIFICATES_COUNT:
            return {
                ...state,
                count: payload,
            };
        case GET_EVALUATION_CERTIFICATES:
            return {
                ...state,
                evaluationsCertificates: payload,
                isLoading: false,
                success: true,
            };
        case EVALUATION_CERTIFICATES_LOADING:
            return {
                ...state,
                certListIsLoading: payload,
            };

        case GET_EVALUATION_CERTIFICATE_PRODUCTS_COUNT_ERROR:
            return {
                ...state,
                manufacturerCount: payload,
            };
        case GET_EVALUATION_CERTIFICATE_PRODUCTS_ERROR:
            return {
                ...state,
                productsWithEvaluations: payload,
                isLoading: false,
                success: false,
            };
        case GET_EVALUATION_CERTIFICATES_COUNT_ERROR:
            return {
                ...state,
                count: payload,
            };
        case GET_EVALUATION_CERTIFICATES_ERROR:
            return {
                ...state,
                evaluationsCertificates: payload,
                isLoading: false,
                success: false,
            };
        default:
        return state;
    }
}
